import { writable } from 'svelte/store';

export const heroSize = writable(null);

export const globalSizes = writable({
    heroH: null,
    navbarH: null,
});

export const filters = writable([]);

export const filterCategories = writable([]);

export const personalLinks = writable([]);

export const studies = writable([]);